export enum BetType {
    TCTBOne,
    TCTBTwo,
    TCTBFour,
    TCTBSeven,
    TCTBEighteen,
    TCTBForty,
    TCTBMaxBet,
}
